import React, { useState, useEffect, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import "../../assets/styles/local/AddDocumentsWithPagination.css";
import "../../assets/styles/local/Documents.css";
import { EyeOutlined } from "@ant-design/icons";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import lockGrey from "../../assets/icons/lockGrey.svg";
import lockBlue from "../../assets/icons/lockBlue.svg";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  ADD_DOCUMENT_PROJECT,
  API_URL,
  CREATE_PROJECT,
  FETCH_DOCUMENT_PROJECT,
  UPDATE_PROJECT_BY_ID,
} from "../../redux/constants/type";
import roundFileSize from "../../utils/Documents/roundFileSize";
import moment from "moment";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import {
  AddDocumentToProject,
  deleteDoc,
  Fetchdocumentbyprojectid,
  UpdateIslocked,
} from "../../redux/actions/action";
import DocumentUploaderWithProgress from "../../components/Common/Document_Uploader_With_Progress";
import DeletePopUp from "../../components/Dailogs/DeletePopUp";
import { getFilePreview } from "../../utils/filePreview/filePreview";
import FilePreviewModal from "../../utils/filePreview/FilePreviewModal";

const ProjectDocuments = (props) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const userId = window.localStorage.getItem("userid");
  const projectId = window.localStorage.getItem("projectid");
  const roleId = window.localStorage.getItem("roleid");
  const userFirstName = window.localStorage.getItem("firstname");
  const userLastName = window.localStorage.getItem("lastname");

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [filePreview, setFilePreview] = useState(null);

  const [deleteDocument, setDeleteDocument] = useState(false);
  const [deleteRowData, setDeleteRowData] = useState(null);
  const [newDoc, setNewDoc] = useState([]);

  const createProject = useSelector((state) => state.user.createProject);
  const updateProjectById = useSelector(
    (state) => state.user.updateProjectById,
  );
  const fetchDocumentProject = useSelector(
    (state) => state.user.fetchDocumentProject,
  );
  const addDocumentProject = useSelector(
    (state) => state.user.addDocumentProject,
  );

  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });

  useEffect(() => {
    if (projectId) {
      dispatch(Fetchdocumentbyprojectid(projectId));
    }
  }, []);

  useEffect(() => {
    if (location.pathname.includes("/addProject")) {
      setNewDoc([]);
      return;
    }
    if (fetchDocumentProject?.status === true) {
      setNewDoc(fetchDocumentProject?.data);
    }
  }, [fetchDocumentProject]);

  const calculatePagination = useCallback(
    (pageNumber) => {
      const records = newDoc || [];
      const startRecordIndex = Math.max(10 * pageNumber - 9, 1);
      const endRecordIndex = Math.min(10 * pageNumber, records.length);
      const tempPaginationObj = {
        totalRecords: records.length,
        currentPage: pageNumber,
        startRecordIndex,
        endRecordIndex,
        totalPages: Math.ceil(records.length / 10),
        records: records.slice(startRecordIndex - 1, endRecordIndex),
      };
      setPaginationObj({ ...tempPaginationObj });
    },
    [newDoc],
  );

  useEffect(() => {
    calculatePagination(1);
  }, [calculatePagination, newDoc]);

  const onFileUploaded = (data) => {
    const newDocument = {
      documentname: data[0].name,
      documentextension: data[0].type,
      documentcontent: "string",
      link: data[0].link,
      documentsize: data[0].size,
      islocked: 0,
      uploadedbyfirstname: userFirstName,
      uploadedbylastname: userLastName,
      userId: userId,
    };

    setNewDoc((prevFileList) => [...prevFileList, newDocument]);
    localStorage.setItem("storedDocs", JSON.stringify([newDocument]));
    setTypeComp(newDocument);
    if (projectId && newDocument.link) {
      dispatch(AddDocumentToProject(userId, projectId, [newDocument]));
    }
  };

  const fileValidationBeforeUpload = (file) => {
    let isValid = true;
    // Check if the document with the same name already exists
    if (newDoc.some((doc) => doc.documentname === file.name)) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: "Document with the same name already exists.",
        },
        false,
      );
      isValid = false;
    }
    return isValid;
  };

  const handleDeleteDocumentFun = () => {
    const updatedFileList = newDoc.filter(
      (item) => item.documentname !== deleteRowData.documentname,
    );
    setNewDoc(updatedFileList);
    if (projectId) {
      dispatch(deleteDoc(deleteRowData.documentid));
    }
    setDeleteDocument(false);
    setDeleteRowData(null);
  };

  const lockDocument = (item) => {
    const updatedFileList = newDoc.map((file) =>
      file.documentid === item.documentid
        ? { ...file, islocked: file.islocked ? 0 : 1 }
        : file,
    );
    setNewDoc(updatedFileList);
    if (projectId) {
      const payload = {
        documentid: item.documentid,
        islocked: item.islocked ? 0 : 1,
      };
      dispatch(UpdateIslocked(payload));
    }
  };

  const storedDocs = JSON.parse(localStorage.getItem("storedDocs") || "[]");

  useEffect(() => {
    if (
      // (createProject?.status === true &&
      //   createProject?.data &&
      //   newDoc?.length) ||
      // (updateProjectById?.status === true &&
      //   updateProjectById?.data &&
      //   newDoc?.length)

      (createProject?.status === true &&
        createProject?.data &&
        storedDocs?.length) ||
      (updateProjectById?.status === true &&
        updateProjectById?.data &&
        storedDocs?.length)
    ) {
      const id = projectId ?? createProject?.data?.projectid;
      dispatch(
        AddDocumentToProject(
          userId,
          id,
          storedDocs || newDoc.filter((data) => data?.link),
        ),
      );
      history.push("/project");
      dispatch({
        type: CREATE_PROJECT,
        data: {},
      });
      dispatch({
        type: UPDATE_PROJECT_BY_ID,
        data: {},
      });
      dispatch({
        type: FETCH_DOCUMENT_PROJECT,
        data: {},
      });
      dispatch({
        type: ADD_DOCUMENT_PROJECT,
        data: {},
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    createProject?.data,
    createProject?.status,
    projectId,
    updateProjectById?.data,
    updateProjectById?.status,
    userId,
  ]);

  // breaking issues in this useEffect 👇
  useEffect(() => {
    if (createProject?.status === true || updateProjectById?.status === true) {
      if (!newDoc?.length === 0) {
        history.push("/project");
        dispatch({
          type: CREATE_PROJECT,
          data: {},
        });
      }
    }
  }, [createProject, updateProjectById]);

  // if issue then uncomment below

  // useEffect(() => {
  //   const shouldNavigate =
  //     (createProject?.status === true || updateProjectById?.status === true) &&
  //     (!newDoc || newDoc.length === 0);

  //   if (shouldNavigate) {
  //     history.push("/project");

  //     // Prevent unnecessary dispatches
  //     if (createProject?.status === true) {
  //       dispatch({
  //         type: CREATE_PROJECT,
  //         data: {},
  //       });
  //     }
  //   }
  // }, [createProject?.status, updateProjectById?.status, newDoc?.length]);

  // breaking issues in this useEffect 👆

  const pdfDownload = (event, documentid, documentname, link) => {
    if (documentid) {
      axios({
        method: "post",
        url: `${API_URL}/api/Files/DownloadToS3?documentid=` + documentid,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
        // data: {
        //   message?.message
        // },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        // var el = document.createElement('div');
        const document = window.document || {};
        const link = document.createElement("a");
        link.href = url;
        link.download = documentname;
        document.body.appendChild(link);
        link.click();
        // link.setAttribute("download", `FinalDocument.pdf`);

        // Append to html link element page
        // document.body.appendChild(link);

        // Start download
        // link.click();

        // Clean up and remove the link
        // link.parentNode.removeChild(link);
        // return docFileDownload;
        // }, 1000)
      });
    } else {
      const url = window.URL.createObjectURL(new Blob([link]));
      document = window.document || {};
      const link = document.createElement("a");
      link.href = url;
      link.download = documentname;
      document.body.appendChild(link);
      link.click();
    }
  };

  const [typeComp, setTypeComp] = useState("");
  console.log("doc path", location.pathname.includes("/Document"));
  useEffect(() => {
    if (
      // !location.pathname.toLowerCase().includes("document") &&
      location.pathname.toLowerCase().includes("document") &&
      typeComp !== ""
    ) {
      props.addUsersData(typeComp);
    }
  }, [location.pathname, typeComp]);

  useEffect(() => {
    if (addDocumentProject.status === true) {
      localStorage.removeItem("storedDocs");
      props.setNoClick?.(false);
      dispatch({
        type: ADD_DOCUMENT_PROJECT,
        data: {},
      });
    }
  }, [addDocumentProject]);

  const renderDocumentRows = () => {
    const docsToRender =
      props.noClick === true ? [...newDoc, ...storedDocs] : newDoc;

    // if (newDoc.length === 0) {
    //   return <span className="noDataDisplay">No data to dispaly!</span>;
    // }

    if (docsToRender.length === 0) {
      return (
        <span className="noDataDisplay">
          {/* No data to dispaly! */}
          {t("No data to display!")}
        </span>
      );
    }

    // return newDoc?.map((item, index) => (
    return docsToRender?.map((item, index) => (
      <tbody key={index} style={{ borderBottom: "0.5px dashed #A5A5A5" }}>
        <tr
          className="products-and-parts-actionGap"
          onDragOver={handleDragOver} // riya code for Doc drag and drop
          onDragLeave={handleDragLeave} // riya code for Doc drag and drop
          onDrop={handleDrop} // riya code for Doc drag and drop
        >
          <td className="d-flex gap-3">
            <img
              className={"products-and-parts-dltIcon"}
              style={{
                cursor:
                  item?.userid === userId ||
                  (item?.islockedby && item?.islockedby?.userid === userId) ||
                  roleId === process.env.REACT_APP_IS_OWNER
                    ? item?.islocked
                      ? "not-allowed"
                      : "pointer"
                    : "not-allowed",
                opacity: item?.islocked ? "0.5" : "1",
              }}
              src={DeleteIcon}
              alt=""
              onClick={() => {
                if (
                  !item?.islocked &&
                  (item?.userid === userId ||
                    (item?.islockedby && item?.islockedby?.userid === userId) ||
                    roleId === process.env.REACT_APP_IS_OWNER)
                ) {
                  setDeleteRowData(item);
                  setDeleteDocument(true);
                }
              }}
            />
            <img
              style={{
                cursor:
                  item?.userid === userId ||
                  (item?.islockedby && item?.islockedby?.userid === userId) ||
                  roleId === process.env.REACT_APP_IS_OWNER
                    ? "pointer "
                    : "not-allowed",
                display: !item.documentid && "none",
              }}
              className="products-and-parts-dltIcon"
              src={item?.islocked ? lockBlue : lockGrey}
              alt=""
              onClick={() => {
                if (
                  item?.userid === userId ||
                  (item?.islockedby && item?.islockedby?.userid === userId) ||
                  roleId === process.env.REACT_APP_IS_OWNER
                ) {
                  lockDocument(item);
                }
              }}
            />
          </td>

          <td
            onClick={(event) =>
              pdfDownload(
                event,
                item?.documentid,
                item?.documentname,
                item?.link,
              )
            }
            className="products-and-parts-documntName"
            style={{ textDecoration: "underline", cursor: "pointer" }}
          >
            {item?.documentname ?? "-"}
          </td>

          <td className="products-and-parts-documntName  hide-on-mobile">
            {roundFileSize(item?.documentsize)}
          </td>

          <td className="products-and-parts-documntName  hide-on-mobile">
            {moment(item?.date).format("DD.MM.YYYY")}
          </td>

          <td className="ps-3  hide-on-mobile">
            {item?.uploadedbyfirstname + " " + item?.uploadedbylastname}
          </td>

          <td className="pointer">
            <EyeOutlined
              onClick={() => {
                setFilePreview(
                  getFilePreview({
                    // file: file, // local upload file
                    url: item.link,
                    type: item.link.split(".").pop(),
                    name: item.documentname,
                  }),
                );
              }}
            />
          </td>
        </tr>
      </tbody>
    ));
  };

  // riya code start for Doc Drag and Drop.
  const [dragging, setDragging] = useState(false); // Track dragging state
  const [draggedRow, setDraggedRow] = useState(null); // Track the row being dragged over
  const handleFileSelection = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      for (const file of files) {
        const data = {
          name: file.name,
          type: file.type,
          size: file.size,
          link: URL.createObjectURL(file), // Generate a temporary link for the file
        };
        onFileUploaded(data);
      }
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragging(false); // Reset dragging state

    const files = event.dataTransfer.files;
    if (files.length > 0) {
      for (const file of files) {
        if (fileValidationBeforeUpload(file)) {
          const data = {
            name: file.name,
            type: file.type,
            size: file.size,
            link: URL.createObjectURL(file), // Generate a temporary link for the file
          };
          onFileUploaded(data);
        }
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault(); // Prevent default behavior (e.g., opening as a link)
    setDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setDragging(false);
  };
  // riya code end for Doc Drag and Drop.

  return (
    <div
      className={
        roleId === process.env.REACT_APP_IS_VIEWER
          ? "pointerEvent container-fluid pt-4 inner-highlighter"
          : "container-fluid inner-highlighter pt-4 tablet-view"
      }
      onDragOver={handleDragOver} // riya code for Doc drag and drop
      onDrop={handleDrop} // riya code for Doc drag and drop
      style={{ border: dragging ? "2px dashed transparent" : "none" }} // riya code for Doc drag and drop
    >
      <div className="d-flex gap-2 pointer ps-2 quotes-div-1 fr">
        <DocumentUploaderWithProgress
          maxSizeInMb={100}
          onUploaded={onFileUploaded}
          multiple={true}
          beforeFileUpload={fileValidationBeforeUpload}
        >
          <div className="d-flex gap-2 pointer ps-2">
            <img
              src={CardAddButton}
              className="products-and-parts-addDocImg"
              alt=""
            />
            <p className="pt-1 products-and-parts-addDocText">
              {/* Add Document */}
              {t("Add Document")}
            </p>
          </div>
        </DocumentUploaderWithProgress>

        <div className="stock-custom-pagination">
          <div className="range-text">
            {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex} of ${paginationObj.totalRecords}`}
          </div>
          <div className="products-and-parts-pagination-buttons">
            <div
              className={`products-and-parts-pagination-button ${
                paginationObj.currentPage === 1 ? "disabled" : ""
              }`}
            >
              <BsChevronLeft />
            </div>
            <div className="pagination-current-page">
              {paginationObj.currentPage}
            </div>
            <div
              className={`products-and-parts-pagination-button ${
                paginationObj.totalPages === 0 ||
                paginationObj.totalPages === paginationObj.currentPage
                  ? "disabled"
                  : ""
              }`}
            >
              <BsChevronRight />
            </div>
          </div>
        </div>
      </div>
      <table className="table table-borderless">
        <thead>
          <tr
            className="products-and-parts-textHeadings"
            style={{ borderBottom: "1px solid #A5A5A5" }}
          >
            <th scope="col products-and-parts-actionGap">
              {/* Actions */}
              {t("Actions")}
            </th>
            <th scope="col products-and-parts-documentGap">
              {/* Document Name */}
              {t("Document Name")}
            </th>
            <th scope="col" class="hide-on-mobile">
              {/* Size */}
              {t("Size")}
            </th>
            <th scope="col" class="hide-on-mobile">
              {/* Date */}
              {t("Date")}
            </th>
            <th scope="col" class="hide-on-mobile">
              {/* Uploaded by */}
              {t("Updated by")}
            </th>
          </tr>
        </thead>
        {renderDocumentRows()}
      </table>

      <FilePreviewModal
        open={filePreview}
        file={filePreview}
        onClose={() => setFilePreview(null)}
      />

      {deleteDocument && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteDocumentFun}
          show={deleteDocument}
          onHide={() => setDeleteDocument(false)}
          title1={
            // "This data will be removed from the system"
            t("This data will be removed from the system")
          }
          title2={
            // "and cannot be undone."
            t("and cannot be done.")
          }
          title3={
            // "Do you want to proceed?"
            t("Do you want to proceed?")
          }
          no={
            // "No"
            t("No")
          }
          yes={
            // "Yes"
            t("Yes")
          }
        />
      )}
    </div>
  );
};

export default ProjectDocuments;
